'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*eslint-disable */
var Play = function Play(props) {
  return _react2.default.createElement(
    _Icon2.default,
    _extends({ viewBox: '0 0 14 14' }, props),
    _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement(
        'title',
        null,
        'Paly icon'
      ),
      _react2.default.createElement(
        'g',
        { fill: 'none', fillRule: 'evenodd' },
        _react2.default.createElement('path', { d: 'M7 0a7 7 0 1 0 0 14A7 7 0 0 0 7 0m0 1c3.308 0 6 2.692 6 6s-2.692 6-6 6-6-2.692-6-6 2.692-6 6-6', fill: 'currentColor' }),
        _react2.default.createElement('path', { stroke: 'currentColor', d: 'M5 4v6l5-3z' })
      )
    )
  );
};
/*eslint-enable */

exports.default = Play;
//# sourceMappingURL=Play.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/src/Icons/dist/components/Play.js